import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';

import * as XLSX from 'xlsx';
export interface EmailAvailabilityResponse {
    available: boolean;
    message?: string;
}

@Injectable({
    providedIn: 'root',
})

export class LookupDataServiceService {
    constructor(private http: HttpClient, private dataService: DataService) { }

    readSheetOneData(file: File): any {
        let data = null;
        const fileReader = new FileReader();
        fileReader.onload = (e: any) => {
            const workbook = XLSX.read(e.target.result, { type: 'binary' });
            const sheetName = workbook.SheetNames[0]; // Assuming sheet number 1
            const worksheet = workbook.Sheets[sheetName];
            data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            console.log('Data from Sheet 1:', data);

        };
        return data;
    }

    clearCache() {
        return this.dataService.clearCache();
    }

    gettitle(refresh: boolean) {
        return this.dataService.getLookupData('/api/lookup/gettitle', refresh);
    }
    getAEXAppStatusType(refresh: boolean) {
        return this.dataService.getLookupData('/api/lookup/getAEXAppStatus', refresh);
    }


    getReportDebitDateType(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getReportDebitDateType',
            refresh
        );
    }

    getHCRoleType(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getHCRoleType',
            refresh
        );
    }

    //  GetRoleTypeForHCAndReach(refresh: boolean) {
    //     return this.dataService.getLookupData(
    //         '/api/lookup/GetRoleTypeForHCAndReach',
    //         refresh
    //     );
    // }

    getlanguage(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getlanguage',
            refresh
        );
    }

    getAccountType(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getAccountType',
            refresh
        );
    }

    getCountryType(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getCountryType',
            refresh
        );
    }
    getRegionTypeList(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getRegionTypeList',
            refresh
        );
    }

    getRoleType(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getRoleType',
            refresh
        );
    }
    getMailCategory(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getMailCategory',
            refresh
        );
    }

    getServiceProvider() {
        return this.dataService.getLookupData('/api/lookup/getServiceProvider', true);
    }

    getDispatchTime() {
        return this.dataService.getLookupData(
            '/api/lookup/getDispatchTime',
            true
        );
    }

    getServiceProviderForAll() {
        return this.dataService.getLookupData(
            '/api/lookup/getServiceProviderForAll',
            true
        );
    }

    getHCYearFormat(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getHCYearFormat',
            refresh
        );
    }

    getRainServiceProvider(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getRainServiceProvider',
            refresh
        );
    }

    getProductCategoryType() {
        return this.dataService.getLookupData(
            '/api/lookup/getProductCategoryType',
            true
        );
    }

    getProductClassification(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getProductClassification',
            refresh
        );
    }

    getProductkmz() {
        return this.dataService.getLookupData(
            '/api/lookup/getProductkmz',
            true
        );
    }

    getConnectionFeeType(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getConnectionFeeType',
            refresh
        );
    }

    getCity(refresh: boolean) {
        return this.dataService.getLookupData('/api/lookup/getCity', refresh);
    }
    getProvince() {
        return this.dataService.getLookupData(
            '/api/lookup/getProvince',
            true
        );
    }
    getCompuscanEnquiryRiskType() {
        return this.dataService.getLookupData(
            '/api/lookup/getCompuscanEnquiryRiskType',
            true
        );
    }
    getShoppingOrderStatus() {
        return this.dataService.getLookupData(
            '/api/lookup/getShoppingOrderStatus',
            true
        );
    }
    getOrderLineItemStatus() {
        return this.dataService.getLookupData(
            '/api/lookup/getOrderLineItemStatus',
            true
        );
    }
    getComplexApplication() {
        return this.dataService.getLookupData(
            '/api/lookup/getComplexApplication',
            true
        );
    }
    getProducts(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getProducts',
            refresh
        );
    }

    getProductsByCategory() {
        return this.dataService.getLookupData(
            '/api/lookup/GetProductsByCategory',
            true
        );
    }
    getProductList(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getProductList',
            refresh
        );
    }

    getProductsbyProvider(params: any) {
        return this.dataService.getRecord(
            '/api/lookup/getProductsbyProvider/' + params
        );
    }

    getKMLFileDetails(params: any) {
        return this.dataService.getRecord(
            '/api/lookup/getKMLFileDetails/' + params
        );
    }

    getVerifiedUsers() {
        return this.dataService.getRecord('/api/lookup/getVerifiedUserList');
    }

    getResellerUsers() {
        return this.dataService.getRecord(
            '/api/lookup/getResellerCustomerList'
        );
    }

    getEmailAvailability(email: string) {
        return this.dataService.getRecord(
            `/api/Application/validateEmail?email=${encodeURIComponent(email)}`
        );
    }

    getResellerCustomerListBySearch(
        search: string,
    ) {
        return this.dataService.getRecord(
            '/api/lookup/getResellerCustomerListBySearch/' + '/' + search
        );
    }

    getVerifiedUserListBySearch(search) {
        return this.dataService.getRecord(
            '/api/lookup/getVerifiedUserListBySearch' + '/' + search
        );
    }

    getAreasByServiceProviderId(ServiceProviderId: number) {
        return this.dataService.getRecord(
            '/api/lookup/getareas/' + ServiceProviderId
        );
    }

    getProductSubCategory(primaryProductId: number) {
        return this.dataService.getRecord(
            '/api/lookup/getProductSubCategory/' + primaryProductId
        );
    }

    //getrouterapplication  (refresh) {
    //    return this.dataService.getRecord('/api/lookup/getrouterapplication', refresh);
    //}
    getrouterapplication(applicationNo: number) {
        return this.dataService.getRecord(
            '/api/lookup/getrouterapplication/' + applicationNo
        );
    }

    getcompleteapplication(refresh: boolean) {
        return this.dataService.getRecord(
            '/api/lookup/getcompleteapplication'

        );
    }

    getRouterApplicationforAddressChange(refresh: any) {
        // return this.dataService.dataForRouteIsCached(
        //     '/api/lookup/getRouterApplicationforAddressChange',
        //     refresh
        // );
        return this.dataService.getRecordWithParams(
            '/api/lookup/getRouterApplicationforAddressChange',
            refresh
        );
    }

    getOptionalConnectionFeeByProductId(primaryProductId: number) {
        return this.dataService.getRecord(
            '/api/lookup/getOptionalConnectionFeeByProductId/' +
            primaryProductId
        );
    }

    //getProductType  (refresh) {
    //    return this.dataService.getLookupData('/api/lookup/getProductType', refresh)
    //}

    getConnectionFee(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getConnectionFee',
            refresh
        );
    }

    getConnectionFeeByServiceProviderId(serviceProviderId: number) {
        return this.dataService.getRecord(
            '/api/lookup/GetConnectionFeeByServiceProviderId/' +
            serviceProviderId
        );
    }

    getProductsByAreaId(areaId: number) {
        return this.dataService.getRecord(
            '/api/lookup/GetProductsByAreaId/' + areaId
        );
    }

    getSystemRoleType(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getSystemRoleType',
            refresh
        );
    }

    getApplicationStausType() {
        return this.dataService.getLookupData(
            '/api/lookup/getApplicationStausType',
            true
        );
    }

    getApplicationStatusTypeForFibre(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getApplicationStatusTypeForFibre',
            refresh
        );
    }

    getCancellationReasons(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getCancellationReasons',
            refresh
        );
    }
    getApplicationStatusTypeForRain(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getApplicationStatusTypeForRain',
            refresh
        );
    }

    getApplicationReferenceString() {
        return this.dataService.getLookupData(
            '/api/lookup/getApplicationReferenceString',
            true
        );
    }

    getRainApplicationReferenceString(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getRainApplicationReferenceString',
            refresh
        );
    }

    getEnumDeviceStatus(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getEnumDeviceStatus',
            refresh
        );
    }

    getEnumPriority() {
        return this.dataService.getLookupData(
            '/api/lookup/getEnumPriority',
            true
        );
    }

    getVumatelOrderStatus(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getVumatelOrderStatus',
            refresh
        );
    }

    getMailProcessStatus(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getMailProcessStatus',
            refresh
        );
    }

    GetAdHocAreaProdMapIdAndPromoCodeBySPAndProdId(serviceProviderId: number, productId: number) {
        return this.dataService.getRecord('/api/lookup/GetAdHocAreaProdMapIdAndPromoCodeBySPAndProdId/' +
            serviceProviderId +
            '/' +
            productId
        );
    }
    getTemplateList(categoryType: any, messageType: any) {
        return this.dataService.getRecord(
            '/api/lookup/getTemplateList/' + categoryType + '/' + messageType
        );
    }
    getIndividualOrGroup() {
        return this.dataService.getLookupData(
            '/api/lookup/getIndividualOrGroup',
            true
        );
    }
    getNotificationTypeList() {
        return this.dataService.getLookupData(
            '/api/lookup/getNotificationTypeList',
            true
        );
    }
    getCoverageStatus() {
        return this.dataService.getLookupData(
            '/api/lookup/getCoverageStatus',
            true
        );
    }
    getOrderStatus() {
        return this.dataService.getLookupData(
            '/api/lookup/getOrderStatus',
            true
        );
    }
    getResponsibilityType(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getResponsibilityType',
            refresh
        );
    }
    getInternalUsers(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getInternalUsers',
            refresh
        );
    }
    getInternalRole(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getInternalRole',
            refresh
        );
    }
    getActionStatus(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getActionStatus',
            refresh
        );
    }
    //getActivityNumber  (refresh) {
    //
    //    return this.dataService.getLookupData('/api/lookup/getActivityNumber', refresh);
    //}

    getActivityNumber(userId: number) {
        return this.dataService.getRecord(
            '/api/lookup/getActivityNumber/' + userId
        );
    }
    getUserActivityNumber(userId: number) {
        return this.dataService.getRecord(
            '/api/lookup/getUserActivityNumber/' + userId
        );
    }

    getComplexUnitNumber(serviceChangeRequestId) {
        return this.dataService.getRecord(
            '/api/lookup/getComplexUnitNumber/' + serviceChangeRequestId
        );
    }

    getActivityNameList(refresh: any) {
        // return this.dataService.dataForRouteIsCached(
        //     '/api/lookup/getActivityNameList',
        //     refresh
        // );
        return this.dataService.getRecordWithParams(
            '/api/lookup/getActivityNameList',
            refresh
        );
    }
    getEnumReminderStatus(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getEnumReminderStatus',
            refresh
        );
    }
    getServiceProviderSalesDashboard(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getServiceProviderSalesDashboard',
            refresh
        );
    }
    getServiceProviderReportData(refresh: boolean) {
        return this.dataService.dataForRouteIsCached(
            '/api/Report/serviceProviderReportData',
            refresh
        );
    }
    getEnumVumatelActivationStatus(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getEnumVumatelActivationStatus',
            refresh
        );
    }
    getOrderLineItemStatusType(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/GetOrderLineItemStatusType',
            refresh
        );
    }
    getResellerList() {
        return this.dataService.getLookupData(
            '/api/lookup/getResellerList',
            true
        );
    }
    getDeliveryChargesList(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getDeliveryChargesList',
            refresh
        );
    }
    getRoleDetailsList(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getRoleDetailsList',
            refresh
        );
    }
    getManageSalesRepList() {
        return this.dataService.getLookupData(
            '/api/lookup/getManageSalesRepList',
            true
        );
    }

    getApplicationForTopUp(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getApplicationForTopUp',
            refresh
        );
    }
    getTopUpList(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getTopUpList',
            refresh
        );
    }
    getCityByRegionType(regionType: any) {
        return this.dataService.getRecord(
            '/api/lookup/getCityByRegionType/' + regionType
        );
    }
    getRuleProducts() {
        return this.dataService.getLookupData(
            '/api/lookup/GetRuleProducts',
            true
        );
    }
    geCostType(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/geCostType',
            refresh
        );
    }
    getRainItemizedBillingList(searchQuery: string) {
        return this.dataService.getDataWithParams(
            '/api/lookup/getRainItemizedBillingList',
            searchQuery,
            true
        );
    }
    getRainItemizedBillingSimNo(searchQuery: string) {
        return this.dataService.getDataWithParams(
            '/api/lookup/getRainItemizedBillingSimNo',
            searchQuery,
            true
        );
    }
    getCustomerNumberList(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getCustomerNumberList',
            refresh
        );
    }
    getSalesUserNameList(refresh: boolean) {
        return this.dataService.getRecordWithParams(
            '/api/ServiceProvider/getSalesUserNameList',
            refresh
        );
    }
    getApplicationStatusForCancellation() {
        return this.dataService.getRecord(
            '/api/lookup/getApplicationStatusForCancellation'
        );
    }

    getApplicationStatusForServiceChange() {
        return this.dataService.getRecord(
            '/api/lookup/getApplicationStatusForServiceChange'
        );
    }

    getBalwinComplexType() {
        return this.dataService.getLookupData(
            '/api/lookup/getBalwinComplexType', true
        );
    }

    getFibreNetComplexType() {
        return this.dataService.getRecord(
            '/api/lookup/getFibreNetComplexType'
        );
    }

    getOctotelPremiseType() {
        return this.dataService.getRecord(
            '/api/lookup/getOctotelPremiseType'
        );
    }

    getvumatelorders() {
        return this.dataService.getRecord('/api/newuser/getvumatelorders');
    }

    getaexorders() {
        return this.dataService.getRecord('/api/lookup/getaexorders');
    }

    getOrderDispatch() {
        return this.dataService.getRecord('/api/lookup/getOrderDispatch');
    }

    getVumatelProductFromAPI() {
        return this.dataService.getRecord(
            '/api/newuser/getVumatelProductFromAPI'
        );
    }

    getVumatelProducts() {
        return this.dataService.getRecord('/api/newuser/getVumatelProducts');
    }

    getVumatelProductMapping() {
        return this.dataService.getRecord(
            '/api/newuser/getVumatelProductMapping'
        );
    }

    getCustomerDiscountPercentage() {
        return this.dataService.getRecord(
            '/api/lookup/getCustomerDiscountPercentage'
        );
    }

    getVoucherCode() {
        return this.dataService.getRecord('/api/lookup/getVoucherCode');
    }

    getISPList() {
        return this.dataService.getRecord('/api/lookup/getISPList');
    }

    getOntBrandList() {
        return this.dataService.getRecord('/api/lookup/getOntBrandList');
    }



    getPromotionList() {
        return this.dataService.getRecord('/api/lookup/getPromotionList');
    }

    getUserBilling() {
        return this.dataService.getRecord('/api/lookup/getUserBilling');
    }

    getBillingRoleTypeList() {
        return this.dataService.getRecord('/api/lookup/getBillingRoleTypeList');
    }

    getMailingStateTypeList() {
        return this.dataService.getRecord(
            '/api/lookup/getMailingStateTypeList'
        );
    }

    getApprovedTypeList() {
        return this.dataService.getRecord('/api/lookup/getApprovedTypeList');
    }

    getSuspendCustomerList() {
        return this.dataService.getRecord('/api/lookup/getSuspendCustomerList');
    }

    getHCUserList() {
        return this.dataService.getRecord('/api/lookup/getHCUserList');
    }

    getRejectReasonsList() {
        return this.dataService.getRecord('/api/lookup/getCancellationRejectReasons');

    }
    getCustomerBillingBalance(referenceNumber: string) {
        return this.dataService.getRecord(
            '/api/Application/getCustomerBillingBalance/' + referenceNumber
        );
    }

    getCustomerInvoice(referenceNumber: number) {
        return this.dataService.getRecord(
            '/api/Application/getCustomerInvoice/' + referenceNumber
        );
    }

    getCustomerInvoiceByInvoiceNo(invoiceNo: string) {
        return this.dataService.getRecord(
            '/api/Application/getCustomerInvoiceByInvoiceNo/' + invoiceNo
        );
    }

    getShoppingOrderDispatch() {
        return this.dataService.getRecord(
            '/api/lookup/getShoppingOrderDispatch'
        );
    }

    getSchoolProduct(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getSchoolProduct',
            refresh
        );
    }

    getJourneyProduct() {
        return this.dataService.getRecord('/api/lookup/getJourneyProduct');
    }
    getNetworkStatusList() {
        return this.dataService.getRecord('/api/lookup/getNetworkStatusList');
    }
    getUserTicketList() {
        return this.dataService.getRecord('/api/lookup/getUserTicketList');
    }
    getSupportHistoryList(supportId) {
        return this.dataService.getRecord(
            '/api/lookup/getSupportHistoryList/' + supportId
        );
    }
    getAllCity() {
        return this.dataService.getRecord('/api/lookup/getAllCity');
    }

    GetBalancePayment() {
        return this.dataService.getRecord('/api/BalancePayment/GetPaymentBalance');
    }

    getPostingClass() {
        return this.dataService.getRecord('/api/lookup/getPostingClass');
    }

    getItemClass() {
        return this.dataService.getRecord('/api/lookup/getItemClass');
    }
    getDebitRunDateType(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getDebitRunDateType',
            refresh
        );
    }
    getFirstTimeDebitRunDateType(refresh: boolean) {
        return this.dataService.getLookupData(
            '/api/lookup/getFirstTimeDebitRunDateType',
            refresh
        );
    }
    GetApplicablePromoList(serviceProviderId, productId) {
        return this.dataService.getRecord('/api/lookup/GetApplicablePromoList/' + serviceProviderId + '/' + productId);
    }

    gettingEmailForPromoSales = function () {
        return this.dataService.post('/api/Report/gettingEmailForPromoSales/')
    }

    getSuspensionNotificationPreferenceType(refresh: boolean) {
        return this.dataService.getLookupData('/api/lookup/getSuspensionNotificationPreferenceType', refresh);
    }

    getSuspensionProcessStatusType(refresh: boolean) {
        return this.dataService.getLookupData('/api/lookup/getSuspensionProcessStatusType', refresh);
    }

    getAllResellerSalesPerson() {
        return this.dataService.getRecord('/api/reseller/getResellerSalesPersonDetailsForAdmin/');
    }

    getLteServiceProviderList() {
        return this.dataService.getRecord('/api/lookup/getLTEServiceProvider');
    }

    getApplicationTypeList() {
        return this.dataService.getLookupData('/api/lookup/getApplicationTypeList', true);
    }

    PaymentStatusTypeList() {
        return this.dataService.getLookupData('/api/lookup/getPaymentStatusTypeList', true);
    }




}
